type AnyObject = { [key: string]: any };

export const copyWithoutId = <T extends AnyObject>(obj: T): Omit<T, 'id'> => {
    const { id, ...rest } = obj;
    return rest;
};
